import { withSuperJSONProps as _withSuperJSONProps, withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import React, { useEffect } from "react";
import Image from "next/image";
import Meta from "../../../components/Meta";
import HeadLine from "../../../components/headLine";
import Likes from "../../../components/likes";
import SponsoredFacilities from '../../../components/hero/SponsoredFacilities';
import Link from "next/link";
import { useUser } from "@auth0/nextjs-auth0/client";
import prisma from '../../../prisma/prisma';
import EntityMappingService from '../../../services/entity-mapping-service';
export const getServerSideProps = _withSuperJSONProps(async function getServerSideProps(context) {
  const facilitiesResult = await prisma.trainingFacility.findMany({
    orderBy: {
      title: 'asc'
    }
  });
  const facilities = EntityMappingService.mapTrainingFacilities(facilitiesResult);
  const sponsoredFacilities = facilities.filter(x => x.isFeatured);
  return {
    props: {
      facilities,
      sponsoredFacilities
    }
  };
}, []);
const Index = ({
  facilities,
  sponsoredFacilities
}) => {
  const {
    user,
    isLoading
  } = useUser();
  return <>
      <Meta title="Training Facilities || AmateurMoto.com | Motocross facilities across the nation" data-sentry-element="Meta" data-sentry-source-file="index.jsx" />
      
      <SponsoredFacilities facilities={sponsoredFacilities} data-sentry-element="SponsoredFacilities" data-sentry-source-file="index.jsx" />
      <div>
        <section className="py-24">
          <div className="container">
            <HeadLine text="Motocross Training Facilities" classes="font-display text-jacarta-700 mb-8 text-center text-3xl dark:text-white" data-sentry-element="HeadLine" data-sentry-source-file="index.jsx" />
            <div className="grid grid-cols-1 gap-[1.875rem] md:grid-cols-2 lg:grid-cols-4">
              {facilities?.map(item => {
              const {
                id,
                title,
                trainers,
                city,
                state,
                profilePicUrl,
                description
              } = item;
              return <article key={id}>
                    <div className="dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2xl block border bg-white p-[1.1875rem] transition-shadow hover:shadow-lg">
                      <figure className="relative">
                        <Link href={`/apps/training-facilities/detail/${id}`}>
                          <Image src={profilePicUrl} alt={title} className="w-full rounded-[0.625rem]" loading="lazy" width={800} height={800} />
                        </Link>
                      </figure>
                      <div className="mt-7 flex items-center justify-between">
                        <Link href={`/apps/training-facilities/detail/${id}`}>
                          <span className="font-display text-jacarta-700 hover:text-accent text-base dark:text-white">
                            {title}
                          </span>
                        </Link>

                      </div>
                      <div className="mt-2 text-sm">
                        <span className="dark:text-jacarta-300">{trainers}</span>
                      </div>

                      <div className="mt-2 text-sm">
                        <span className="dark:text-jacarta-900">{city}, {state}</span>
                      </div>

                      <div className="mt-4 text-sm">
                        <span className="light:text-jacarta-100">{description}</span>
                      </div>

                      <div className="mt-2 flex items-center justify-between">
                        <Link href={`/apps/training-facilities/detail/${id}`}>
                          <button className="text-accent font-display text-sm font-semibold">
                            Click for more details
                          </button>
                        </Link>

                        <Likes like={1} classes="flex items-center space-x-1" />
                      </div>

                      {/* {user?.id === userId && (
                        <div className="mt-10 text-center">
                          <Link
                            href={`/apps/training-facility/edit/${id}`}
                            className="bg-accent shadow-accent-volume hover:bg-accent-dark inline-block rounded-full py-3 px-8 text-center font-semibold text-white transition-all"
                          >
                            Edit Profile
                          </Link>
                        </div>
                       )} */}
                    </div>
                  </article>;
            })}
            </div>

            <div className="mt-10 text-center">
              <Link href="/contact-us" className="bg-accent shadow-accent-volume hover:bg-accent-dark inline-block rounded-full py-3 px-8 text-center font-semibold text-white transition-all" data-sentry-element="Link" data-sentry-source-file="index.jsx">
                Contact Us to get your Facility added.
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>;
};
export default _withSuperJSONPage(Index);